// src/utils/seriesUtils.js
import defaultSeries from "../data/series.json";

const SERIES_KEY = "series";

export function initializeSeries() {
  if (!localStorage.getItem(SERIES_KEY)) {
    localStorage.setItem(SERIES_KEY, JSON.stringify(defaultSeries));
  }
}

export function getAllSeries() {
  initializeSeries();
  return JSON.parse(localStorage.getItem(SERIES_KEY));
}

export function getSeriesById(id) {
  initializeSeries();
  const seriesList = JSON.parse(localStorage.getItem(SERIES_KEY));
  return seriesList.find((s) => s.id === id);
}

export function addSeries(newSeries) {
  initializeSeries();
  const seriesList = JSON.parse(localStorage.getItem(SERIES_KEY));
  seriesList.push(newSeries);
  localStorage.setItem(SERIES_KEY, JSON.stringify(seriesList));
}

// **Función añadida** para borrar una serie
export function deleteSeries(id) {
  initializeSeries();
  let seriesList = JSON.parse(localStorage.getItem(SERIES_KEY));
  seriesList = seriesList.filter((s) => s.id !== id);
  localStorage.setItem(SERIES_KEY, JSON.stringify(seriesList));
  return seriesList;
}
